import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography } from "antd";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const StaffDamageForm = props => {
  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        numberOfDead: props.record.damage.numberOfDead,
        numberOfInjured: props.record.damage.numberOfInjured,
        numberOfAbsent: props.record.damage.numberOfAbsent,
        durationOfAbsence: props.record.damage.durationOfAbsence,
        reasonOfAbsence: props.record.damage.reasonOfAbsence,
        furtherDetails: props.record.damage.furtherDetails
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.numberOfDead = elvis(values.numberOfDead);
    newDamage.damage.numberOfInjured = elvis(values.numberOfInjured);
    newDamage.damage.numberOfAbsent = elvis(values.numberOfAbsent);
    newDamage.damage.durationOfAbsence = elvis(values.durationOfAbsence);
    newDamage.damage.reasonOfAbsence = elvis(values.reasonOfAbsence);
    newDamage.damage.furtherDetails = elvis(values.furtherDetails);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Working Staff"
      />
      <Form.Item label="N. of dead" name="numberOfDead">
        <InputNumber />
      </Form.Item>
      <Form.Item label="N. of injured" name="numberOfInjured">
        <InputNumber />
      </Form.Item>
      <Form.Item label="N. of absent" name="numberOfAbsent">
        <InputNumber />
      </Form.Item>
      <Form.Item label="Duration of absent (working days)" name="durationOfAbsence">
        <InputNumber />
      </Form.Item>
      <Form.Item label="Reason of absent" name="reasonOfAbsence">
        <Input />
      </Form.Item>
      <Form.Item label="Further details" name="furtherDetails">
        <Input />
      </Form.Item>
    </Form>
  );
};

export default StaffDamageForm;